import { MenuLink } from "../shared/interface/bcmenulink";

const menu: MenuLink[] = [
  {
    iconLink: "home",
    path: "/",
    label: "Inicio",
  },
  {
    iconLink: "image",
    path: "/rekognition",
    label: "AWS Rekognition",
  },
  {
    iconLink: "image",
    path: "/rekognition-lote",
    label: "AWS Rekognition - Lote",
  },
  
];

export { menu };
